import styles from "./index.module.css";
import { locationMapping } from "../../../utils/constant";
import { convert_usd_to_nzd } from "../../../utils/conversion";
import { PulseLoader } from "react-spinners";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const PriceChangeTable = (props) => {
  const { loading } = useSelector((store) => store.livePrice);
  const { source, currency } = useSelector((store) => store.constant);
  const navigate = useNavigate();

  // Format website display name
  const formatWebsiteName = (website) => {
    if (website === 'aelia_auckland') return 'auckland_dutyfree';
    if (locationMapping[website]) {
      return `${locationMapping[website].location} ${locationMapping[website].brand}`;
    }
    return website?.replace(/_/g, ' ') || website;
  };

  const handleProductClick = (sourceProductTitle) => {
    console.log("handleProductClick called with:", sourceProductTitle);
    if (sourceProductTitle) {
      navigate(`/dashboard/df-products?search=${encodeURIComponent(sourceProductTitle)}`);
    }
  };

  const handleRowClick = (product) => {
    console.log("Row clicked:", product);
  };

  return (
    <div className={styles["container"]}>
      <div className={styles["table"]}>
        <div className={styles["thead"]}>
          <div className={styles["thead_cell"]}>Date</div>
          <div className={styles["thead_cell"]}>Location</div>
          <div className={styles["thead_cell"]}>Product</div>
          <div className={styles["thead_cell"]}>New Price</div>
          <div className={styles["thead_cell"]}>Previous Price</div>
          <div className={styles["thead_cell"]}>% Change</div>
          <div className={styles["thead_cell"]}>My Price</div>
          <div className={styles["thead_cell"]}>% Diff</div>
        </div>
        {loading ? (
          <div className="loader-container">
            <PulseLoader />
          </div>
        ) : (
          <div className={styles["tdata"]}>
            {props?.data.map((product, index) => (
              <div 
                className={styles["trow"]} 
                key={index}
              >
                <div className={styles["trow_cell"]}>
                  {new Date(product.new_price_date).toLocaleDateString("en-GB")}
                </div>
                <div className={styles["trow_cell"]}>{formatWebsiteName(product.website)}</div>
                <div 
                  className={styles["trow_cell"] + " " + styles["clickable-product"]}
                  onClick={() => {
                    console.log("Product clicked:", product.title);
                    console.log("Source product title:", product.source_product?.title);
                    if (product.source_product?.title) {
                      navigate(`/dashboard/df-products?search=${encodeURIComponent(product.source_product.title)}`);
                    }
                  }}
                  title="Click to search for this product"
                >
                  {product.title}
                </div>
                <div className={styles["trow_cell"]}>
                  {convert_usd_to_nzd(product.new_price, currency, product)}
                </div>
                <div className={styles["trow_cell"]}>
                  {product.old_price && !isNaN(product.old_price)
                    ? convert_usd_to_nzd(product.old_price, currency, {
                        conversion_rate_nzd: product.old_conversion_rate_nzd,
                        conversion_rate_aud: product.old_conversion_rate_aud,
                        conversion_rate_sgd: product.old_conversion_rate_sgd,
                      })
                    : "-"}
                </div>
                <div
                  className={styles["trow_cell"] + " " + styles["down"]}
                  style={{
                    color: Number(product.percentage_diff) >= 0 ? "green" : "",
                  }}
                >
                  {product.percentage_diff && !isNaN(product.percentage_diff) && Number(product.percentage_diff) !== 0
                    ? Number(product.percentage_diff).toFixed(2) + "%"
                    : "-"}
                </div>
                <div className={styles["trow_cell"]}>
                  {product.latest_source_price
                    ? convert_usd_to_nzd(product.latest_source_price, currency)
                    : "-"}
                </div>
                <div className={styles["trow_cell"] + " " + styles["down"]}>
                  {product.latest_source_price && !isNaN(product.latest_source_price) && Number(product.latest_source_price) !== 0
                    ? (() => {
                        const diffPercent = ((Number(product.new_price) - Number(product.latest_source_price)) / Number(product.latest_source_price)) * 100;
                        return diffPercent !== 0 ? diffPercent.toFixed(2) + "%" : "-";
                      })()
                    : "-"}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PriceChangeTable;
